export default __webpack_public_path__ + "static/media/hrt.515947dc.png";